import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as Store from '../../store';

// Websockets
import { WebsocketsListener } from '../../utils/ws';

@Component
export default class Login extends Vue {
    public username: string = '';
    public password: string = '';

    wsListener: WebsocketsListener;

    constructor() {
        super();

        this.wsListener = new WebsocketsListener();

        // Assign session values to store for global dispatch
        this.wsListener.onPost('auth.login', (success: boolean, data: any) => {
            if (!success) {
                Store.commitLoaderVisibility(this.$store, false);
                return alert(data);
            }

            // Save the user data to localstorage
            this.wsListener.setAuthState(true, data);

            // Wait few ms to write the things
            setTimeout(() => {
                Store.commitLoggedInState(this.$store, true);
                Store.commitLoggedInUser(this.$store, data);

                this.wsListener.reconnect(() => {
                    if (this.$root.$options.router) {
                        this.$root.$options.router.push('/');
                    }
                });
            }, 100);
        });
    }

    doLogin() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.login', {
            user: this.username,
            pass: this.password,
            scope: 'admin',
        });

        return false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/login/index.ts